import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';
import GenericErrorMessage from '../generic_error_message/GenericErrorMessage';

export class ModalWithoutTracker extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        this.props.setInfosModalProspect({ ...this.props.prospect, [e.target.name]: e.target.value })
    }


    render() {
        const avaliableSendProspect = this.props.modalProspectAvaliable
        const { coupon } = this.props

        let couponText = 'PROMO15'

        if (coupon && coupon.status === 0) {
            couponText = coupon.text
        }

        if (!this.props.isModalWithoutTrackerActive)
            return <div />
        return (
            <div className="comp_modalpagamento tracker-modal">
                <div className="modalcontents">
                    <div className="contents">
                        <div className="header">
                            <img
                                className="logo-seguros-promo"
                                src="/assets/images/logo.png"
                                alt="Logo Seguros Promo" />
                        </div>
                        <hr />
                        <div className="modalmiddle">
                            <h3>Que bom que você quer viajar com mais segurança! Primeiro, preencha os dados abaixo, garanta a melhor condição do mercado e um cupom de desconto!</h3>
                            <div className="modal-label">Nome</div>
                            <input
                                type="text"
                                placeholder="Nome"
                                value={this.props.prospect.name}
                                name="name"
                                onChange={this.handleChange}
                                onBlur={e => this.props.trackerModalValidatorHandlerBlur(e.target.name)}
                            />
                            <div className="errorMessage">
                                <GenericErrorMessage
                                    errors={this.props.prospect.errors}
                                    anchor="name"
                                    field="name"
                                />
                            </div>
                            <div className="modal-label">E-mail</div>
                            <input
                                placeholder="email@exemplo.com"
                                type="text"
                                name="email"
                                value={this.props.prospect.email}
                                onChange={this.handleChange}
                                onBlur={e => this.props.trackerModalValidatorHandlerBlur(e.target.name)}
                            />
                            <div className="errorMessage">
                                <GenericErrorMessage
                                    errors={this.props.prospect.errors}
                                    anchor="email"
                                    field="email"
                                />
                            </div>
                            <div className="modal-label">Celular</div>
                            <MaskedInput
                                placeholder="(xx) 00000-0000"
                                guide
                                name="phone"
                                inputMode="numeric"
                                value={this.props.prospect.phone}
                                type="tel"
                                mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d?/]}
                                onChange={this.handleChange}
                                onBlur={e => this.props.trackerModalValidatorHandlerBlur(e.target.name)}
                            />
                            <div className="errorMessage">
                                <GenericErrorMessage
                                    errors={this.props.prospect.errors}
                                    anchor="phone"
                                    field="phone"
                                />
                            </div>
                            <div className="cupom-text modal-label">Cupom</div>
                            <div className="cupom-label">{couponText}</div>
                            <input
                                type="button"
                                value="ATIVAR MEU DESCONTO"
                                className={`apply-button ${avaliableSendProspect ? 'avaliable' : ''}`}
                                onClick={() => this.props.redirectToTracker(couponText)}
                            />
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default ModalWithoutTracker;



// WEBPACK FOOTER //
// ./src/components/common/modal_without_tracker/ModalWithoutTracker.jsx